import React, { useState, useContext } from 'react';
import { Navbar, Container, Row, Col, Button, Offcanvas } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './site.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, Redirect } from 'react-router-dom';
import { AuthContext } from '../../src/app/Context/auth';
import localImage from './Home.jpg';
import localImage1 from './MOSAIC169.jpg';
import localImage2 from './HomeLogin.jpg';
import localImage3 from './Laboratorio.jpeg';
import localImage4 from './BOTAO-GEOCONTROLE.jfif';
import marcageo from './marcageo+.png';
import Frase from './Frase.png';
import axios from 'axios'; // npm i axios
import Conexao from '../../src/app/Config/conexao';
import { FaGlobe, FaInstagram, FaLinkedin } from 'react-icons/fa';

function Site() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showSecondSidebar, setShowSecondSidebar] = useState(false);
  const [showSobreSidebar, setShowSobreSidebar] = useState(false);
  const [showGeocontroleSidebar, setShowGeocontroleSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const [liClickedcor, setLiClickedcor] = useState(false);
  const [liClicked1, setLiClicked1] = useState(false);
  const [liClicked2, setLiClicked2] = useState(false);
  const [liClicked3, setLiClicked3] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(localImage);
  const [sucesso, setSucesso] = useState('');
  const { setLogado } = useContext(AuthContext);
  const [usuario, setUsuario] = useState('Admin');
  const [senha, setSenha] = useState('Admin');

  const images = [
    localImage,
    localImage1,
    localImage2,
    localImage3,
    localImage4,
  ];

  const handleCloseSidebar = () => {
    setShowSidebar(false);
    setBackgroundImage(images[0])
  }

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    setBackgroundImage(images[index]);

  }

  const handleLiClick = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked(true);
    handleShowSecondSidebar();
    console.log(backgroundImage);
    handleCloseSobreSidebar(index); setLiClicked1(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };


  const handleCloseSecondSidebar = () => {
    setShowSecondSidebar(false);
    setBackgroundImage(images[1])
  }

  const handleShowSecondSidebar = () => {
    setShowSecondSidebar(true);
    setBackgroundImage(images[1])
  }

  const handleCloseSobreSidebar = (index) => {
    setShowSobreSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickSobre = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked1(true);
    setShowSobreSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };

  const handleCloseGeocontroleSidebar = (index) => {
    setShowGeocontroleSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickGeocontrole = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked3(true);
    setShowGeocontroleSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseSobreSidebar(index); setLiClicked1(false);
  };

  const togglePasswordVisibility = () => setPasswordShown(!passwordShown);

  function alterarEmail(event) {
    setUsuario(event.target.value);
  }

  function alterarSenha(event) {
    setSenha(event.target.value);
  }

  async function login(e) {
    e.preventDefault();
    console.log(usuario, senha);
    const obj = { usuario, senha };
    const res =''
    if (usuario === "" && senha === "") {
      setSucesso('I');
    }
    else {
      if (res === '') {
        // setLogado(false);
        // setSucesso('N');
        setLogado(true);
        setSucesso('S');
      } else {
        setLogado(true);
        setSucesso('S');
      }
    }
  }

  function SalvaUser() {
    localStorage.usuario = document.getElementById("floatingInput").value;
  }

  return (
    <div className="home">
      <div className="banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <Container>
          <div>

            <div className="text-center">
              {showSidebar === false ? <div className="image-wrapper">
                <img src={marcageo} className="image-adjust" alt="Descrição" />
                <img src={Frase} className="image-adjust" alt="Descrição" />
              </div> : null}
            </div>

          </div>
        </Container>
        <div className="sidebar-button">
          <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
            <div className="icon-container">
              <i className="bi bi-list icon-circle"></i>
            </div>
          </Button>
        </div>
      </div>
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Sidebar Login */}
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebar">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasLabel" style={{ color: 'white' }}>Menu</h5>
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} onClick={() => handleLiClick(2)}>
              <Button variant="link" style={{
                textDecoration: 'none',
                color: liClicked ? '#00221A' : 'white',
                fontSize: '1.5em'
              }}>Login <span className="icon-right move-right"><i className="bi bi-chevron-right" style={{textDecoration: 'none',color: liClicked ? '#00221A' : 'white'}}></i></span></Button>
            </li>
            <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li>
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Sidebar tela Login */}
      <Offcanvas show={showSecondSidebar} onHide={() => { handleCloseSecondSidebar(); setLiClicked(false); }} className={`second-sidebar ${!showSecondSidebar ? 'second-sidebar-closed' : ''}`}>
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasLabel" style={{ color: 'white' }}>Login</h5>
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSecondSidebar(); setLiClicked(false); }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <div className="login-container">
            <form>
              <div className="d-flex justify-content-center align-items-center vh-80">
                <div className="card p-4" style={{ width: '20rem', backgroundColor: '#00221A', border: 'none' }}>
                  <div className="form-group">
                    <input type="text" onChange={alterarEmail} className="custom-input form-element" id="username" placeholder="admin" />
                  </div>
                  <div className="form-group mt-3">
                    <div className="input-group">
                      <input
                        onChange={alterarSenha}
                        type={passwordShown ? "text" : "password"}
                        className="custom-inputbot form-element"
                        id="password"
                        placeholder="admin"
                      />
                      <button
                        type="button"
                        className="btnpassword form-element"
                        onClick={togglePasswordVisibility}
                      >
                        <i className={passwordShown ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"}></i>
                      </button>
                    </div>
                  </div>
                  <br />
                  <button onClick={(e) => login(e)} className="btn btn-success mt-4 btn-block" style={{ borderRadius: '100px', width: '80%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>Acessar</button>
                  {sucesso === 'N' ? <div className="alert alert-danger mt-2" role="alert">Login ou senha inválida.</div> : null}
                  {sucesso === 'I' ? <div className="alert alert-danger mt-2" role="alert">Por favor digitar login e senha</div> : null}
                  {sucesso === 'S' ? <Redirect to='/app/home' /> : null}
                </div>
              </div>
            </form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Sidebar sobre */}
      <Offcanvas show={showSobreSidebar} onHide={() => { handleCloseSobreSidebar(1); setLiClicked1(false); }} className={`second-sidebar ${!showSobreSidebar ? 'second-sidebar-closed' : ''}`}>
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasLabel" style={{ color: 'white' }}>Sobre o Geo+</h5>
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSobreSidebar(1); setLiClicked1(false); }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <div className="geo-plus">
            <div className="content">
              <h2>A Geo+ é uma plataforma inovadora desenvolvida para otimizar o processo de processamento, análise e comunicação de dados dos serviços prestados pela Geocontrole.</h2>
              <h3>Principais funcionalidades:</h3>
              <ul>
                <li>Cálculo automatizado e certificado de dados e resultados de ensaios laboratoriais.</li>
                <li>Registo e processamento de dados resultantes de atividades e sondagens geotécnicas de campo.</li>
                <li>Registo e processamento de dados resultantes de atividades de trabalho de pesquisa geológica/mineral.</li>
              </ul>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Sidebar Geocontrole */}
      <Offcanvas show={showGeocontroleSidebar} onHide={() => { handleCloseGeocontroleSidebar(1); setLiClicked3(false); }} className={`second-sidebar ${!showGeocontroleSidebar ? 'second-sidebar-closed' : ''}`}>
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasLabel" style={{ color: 'white' }}>Geocontrole</h5>
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseGeocontroleSidebar(1); setLiClicked3(false); }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <div className="geocontrole-info">
            <div className="content">
              <p>A Geocontrole é uma empresa multinacional líder em soluções de geotecnia, ensaios laboratoriais, e pesquisa mineral. Conta hoje com uma atuação destacada em países como Brasil, Portugal e Moçambique.</p>
              <p>Nossa missão é fornecer serviços de alta qualidade, inovadores e sustentáveis, contribuindo para o desenvolvimento seguro e eficiente de projetos em diversos setores.</p>
              <div className="social-media">
                <p><FaGlobe /><a href="http://geocontrole.com" target="_blank" rel="noopener noreferrer" className="social-link"> geocontrole.com</a></p>
                <p><FaInstagram /> <a href="https://www.instagram.com/geocontrole" target="_blank" rel="noopener noreferrer" className="social-link">geocontrole</a></p>
                <p><FaLinkedin /> <a href="https://www.linkedin.com/company/geocontrole" target="_blank" rel="noopener noreferrer" className="social-link">geocontrole</a></p>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default Site;
